import { PetTypeId } from 'types/Pet';

export const RoomRuleTypeIds = {
    TotalCount: 1,
    PetSize: 2,
    TotalPetWeight: 3,
    WeightRange: 4
} as const;

export type RoomRuleTypeId = (typeof RoomRuleTypeIds)[keyof typeof RoomRuleTypeIds];

export type SizeEligibility =
    | null
    | 'empty'
    | 'empty_match'
    | 'active_match'
    | 'mismatch'
    | 'inconsistent';

export interface Room {
    id: number;
    name: string;
    description?: string;
    uuid?: string;
    photos: Array<string>;

    pet_type_list: Array<string>;

    room_units: Array<RoomUnit>;
    room_rules: Array<RoomRule>;

    restrictedCatBreedList: Array<number>;
    restrictedDogBreedList: Array<number>;
    restrictedPetTagList: Array<string>;
    staffIds: Array<number>;
}

export interface RoomUnit {
    id: number;
    uuid: string;
    name: string;
    active: boolean;
    available: boolean;
    occupancy: number;
    activeSizeRuleId: number | null;
    sizeEligibility: unknown | null;
}

export interface RoomRule {
    id: number;
    uuid: string;
    description?: string;
    ruleTypeId: RoomRuleTypeId;
    ruleData: RoomRuleData;
    rawRuleData: string;
}

export type RoomRuleData =
    | RoomRuleTotalCountData
    | RoomRuleTotalPetWeightData
    | Array<RoomRulePetSizeData>
    | Array<RoomRuleWeightRangeData>
    | Record<string, unknown>
    | Array<Record<string, unknown>>;

export interface RoomRuleTotalCountData {
    uuid?: string;
    quantity?: number;
}

export interface RoomRulePetSizeData {
    uuid?: string;
    quantity?: number;
    petTypeId?: PetTypeId | string;
    sizeId?: string;
}

export interface RoomRuleTotalPetWeightData {
    uuid?: string;
    totalWeight?: number;
    weight?: number;
    maxWeight?: number;
}

export interface RoomRuleWeightRangeData {
    uuid?: string;
    quantity?: number;
    petTypeId?: PetTypeId | string;
    sizeId?: string;
    minWeight?: number | null;
    maxWeight?: number | null;
    min?: number | null;
    max?: number | null;
    fromWeight?: number | null;
    toWeight?: number | null;
}
